// This file exports the Luminous exports in the ES6 Module Spec, which is compatible with the commonjs spec
import Luminous from "./Luminous";
import LuminousGallery from "./LuminousGallery";

export { Luminous, LuminousGallery };
